(function ($) {

console.log('test');
$('#attachment').bind('change', function() { 
var fileName = ''; fileName = $(this).val(); 
$('#file-selected').html(fileName.replace(/^.*\\/, ""));
}) 


})(jQuery);